import {atom, useAtom} from "jotai";
import {useCommonParams} from "@/hooks/index";
import {useEffect} from "react";
import {ORGANIC_TRACK_CD_TYPE} from "@/const";

const isOrganicUserAtom = atom<boolean>(false);

const useOrganicUser = () => {
  const [isOrganicUser, setIsOrganicUser] = useAtom(isOrganicUserAtom)
  const {media, trackCdType} = useCommonParams()
  useEffect(() => {
    if (trackCdType) {
      setIsOrganicUser(ORGANIC_TRACK_CD_TYPE[media.toUpperCase()].includes(trackCdType))
    }
  }, [media, setIsOrganicUser, trackCdType])

  return [isOrganicUser]
}

export default useOrganicUser;